import ProfileIcon from '@/ui//icon/profileIcon/ProfileIcon';
import { Container, IconWrapper, ModalWrapper } from './HeaderMenuStyles';
import ProfileModal from '@/ui//modals/profileModal/ProfileModal';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

const HeaderMenu = () => {
  const [openModal, setOpenModal] = useState(false);
  const user = useSelector((state: any) => state.user.info);

  const modalRef = useRef<HTMLDivElement>(null);
  const iconRef = useRef<HTMLDivElement>(null);

  const handleClickOutSide = (e) => {
    if (
      modalRef.current &&
      !modalRef.current.contains(e.target) &&
      !iconRef.current.contains(e.target)
    ) {
      setOpenModal(false);
    }
  };

  useEffect(() => {
    if (openModal) {
      document.addEventListener('click', handleClickOutSide);
    } else {
      document.removeEventListener('click', handleClickOutSide);
    }

    return () => {
      document.removeEventListener('click', handleClickOutSide);
    };
  }, [openModal]);

  const [t] = useTranslation('signIn');

  return (
    <>
      <Container>
        {Object.keys(user).length > 0 ? (
          <IconWrapper ref={iconRef}>
            <ProfileIcon onClick={() => setOpenModal((prev) => !prev)} />
          </IconWrapper>
        ) : (
          <Button
            variant="default"
            className="bg-main"
            onClick={() => (window.location.href = '/signin')}
          >
            {t('Login')}
          </Button>
        )}
      </Container>

      <ModalWrapper ref={modalRef}>
        <ProfileModal
          name={user.fullname}
          plan={user.user_type}
          email={user.email}
          isVisible={openModal}
          close={() => setOpenModal(false)}
        />
      </ModalWrapper>
    </>
  );
};

export default HeaderMenu;
